import axios, { AxiosRequestConfig } from "axios";

const brasilApiCnpjInstance = axios.create({
  timeout: 25000,
  baseURL: "https://brasilapi.com.br/api/cnpj/v1/",
});

const brasilApiCepInstance = axios.create({
  timeout: 25000,
  baseURL: "https://brasilapi.com.br/api/cep/v1/",
});

const brasilApiBancosInstance = axios.create({
  timeout: 25000,
  baseURL: "https://brasilapi.com.br/api/banks/v1",
});

export const brasilApiService = {
  getCnpj: (cnpj: string, config?: AxiosRequestConfig<any>) =>
    brasilApiCnpjInstance.get(cnpj, config),

  getCep: (cep: string, config?: AxiosRequestConfig<any>) =>
    brasilApiCepInstance.get(cep, config),

  getBancos: (config?: AxiosRequestConfig<any>) =>
    brasilApiBancosInstance.get("", config),
  getBancoByCode: (code: string, config?: AxiosRequestConfig<any>) =>
    brasilApiBancosInstance.get(code, config),
};
